
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter1Off as ObiFilter1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-1-off.js';
 
 
 

 
 export const ObiFilter1Off = createComponent({
   react: React,
   tagName: 'obi-filter-1-off',
   elementClass: ObiFilter1OffElement,
   events: {
     
   }
  });
 
 